import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <RankingSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <MediaSection />
        <TopicsSection />
        <ContactSection />
        <AppSection />
        <CarouselSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}